import { Fragment} from "react"
import type { TaxCodeType } from "../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi } from "utils"


export function IsActive(props: {
    id: TaxCodeType
    refetch?: () => void
}) {
    const api = useApi()

    const onSubmit = (value: TaxCodeType) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/taxcode/changestatus",
                    {
                        tax_id: value.tax_id,
                        taxdel: !value.is_deleted
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => {
                        if (err.response && err.response.status === 400) {
                            return err.response.data.message || "Bad Request";
                        } else {
                            return "An error occurred";
                        }
                    }
                }
            ).then(() => {
                props?.refetch && props.refetch()
            }).catch(() => {}).finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle 
                isChecked={props.id.is_deleted} 
                onClick={() => {
                    onSubmit(props.id);
                }} />
        </Fragment>
    )
}